import React from "react";
import { SectionTitle, Highlight, Prose, Reveal, PETROL } from "@/components/home/homeUi";

export default function HomeCommonPoint() {
  return (
    <section
      id="kozos-pont"
      data-testid="home-common-point"
      className="px-6 md:px-10 py-10 md:py-14 border-t border-hairline"
    >
      <SectionTitle testId="home-common-point-title" className="mb-7 md:mb-8">
        Az emberi kapcsolódás mindannyiunk
        <br />
        <em className="text-gold" style={{ fontStyle: "italic" }}>közös pontja</em>
      </SectionTitle>
      <Prose>
        <p>
          Nem számít, milyen hivatást választottál, mivel foglalkozol, fizikai vagy
          szellemi munkát végzel, milyen családban nőttél fel, vagy milyen
          élethelyzetben vagy jelenleg.
        </p>
      </Prose>
      <Highlight className="my-7 md:my-9" testId="home-common-point-highlight">
        <span className="text-gold">
          Egy dolog biztosan közös bennünk: mindannyian emberi kapcsolódásokon
          keresztül éljük az életünket.
        </span>
      </Highlight>
      <Prose>
        <p>
          Kapcsolódunk a szüleinkhez, gyermekeinkhez, társunkhoz, barátainkhoz,
          munkatársainkhoz és a körülöttünk élő emberekhez. Ezekben a kapcsolódásokban
          folyamatosan megmutatkozik, hogyan működünk, milyen értékek mentén
          választunk, hogyan viszonyulunk önmagunkhoz és egymáshoz. Éppen ezek a
          hétköznapi helyzetek kínálhatják a legnagyobb lehetőségeket arra, hogy
          egészen új nézőpontból ismerjük meg önmagunkat.
        </p>
      </Prose>
      <Reveal className="mt-9 md:mt-11 max-w-2xl mx-auto">
        <div
          data-testid="home-common-point-question"
          className="relative px-7 md:px-12 py-9 md:py-11 text-center bg-tinted"
          style={{ borderTop: `1px solid ${PETROL}40`, borderBottom: `1px solid ${PETROL}40` }}
        >
          <p className="font-serif-display italic text-graphite text-[20px] sm:text-[22px] md:text-[25px] leading-[1.55]">
            Mi történne, ha a megszokott reakcióink helyett már egészen más
            minőségből tudnánk választani?
          </p>
        </div>
      </Reveal>
    </section>
  );
}
